<template>
  <LayoutBasic
    :showListPrepend="false"
    :linksMenu="linksMenu"
    :routeBack="{ name: 'empresa.dashboard' }"
    routeBackLabel="Empresa"
    mobileTitle="Reportes"
  >
    <template v-slot:navigation-content>
      <div class="modulo">
        <span class="modulo-icono"><v-icon size="20" color="#e3b08a">mdi-chart-box-outline</v-icon></span>
        <span class="modulo-texto">
          <span class="modulo-eyebrow">Módulo</span>
          <span class="modulo-nombre">Reportes</span>
        </span>
      </div>
    </template>

    <template v-slot:vista-previa>
      <router-view />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "EmpresaReportesLayout",
  components: { LayoutBasic },
  computed: {
    linksMenu() {
      // En el orden en que se consultan: primero lo que se mira todos los días
      return [
        { header: "Ventas" },
        { name: "Resumen del día", icon: "mdi-calendar-today-outline", route_name: "empresa.ventas.resumen.diario" },
        { name: "Métricas de ventas", icon: "mdi-chart-line", route_name: "empresa.ventas.resumen" },
        { name: "Análisis mensual", icon: "mdi-chart-bar", route_name: "empresa.ventas.comparativo.mes" },

        { header: "Compras y gastos" },
        { name: "Gastos", icon: "mdi-cash-minus", route_name: "empresa.gastos" },
        { name: "Compras por mes", icon: "mdi-chart-timeline-variant", route_name: "empresa.compras.mensual" },
        { name: "Compras por proveedor", icon: "mdi-truck-delivery-outline", route_name: "empresa.compras.proveedor" },

        { header: "Clientes" },
        { name: "Cuentas corrientes", icon: "mdi-account-cash-outline", route_name: "empresa.clientes.cuentascorrientes" },

        { header: "Contabilidad" },
        { name: "Balance mensual", icon: "mdi-calendar-month-outline", route_name: "empresa.contabilidad.balance-mensual" },
        { name: "Cuenta contable", icon: "mdi-book-open-variant", route_name: "empresa.contabilidad.cuenta-contable" },
        { name: "Flujo de caja", icon: "mdi-trending-up", route_name: "empresa.general.flujo-caja" },
      ];
    },
  },
};
</script>

<style scoped>
.modulo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
}
.modulo-icono {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(186, 107, 48, 0.18);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.modulo-texto {
  display: flex;
  flex-direction: column;
}
.modulo-eyebrow {
  font-size: 10px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #8a8a8a;
}
.modulo-nombre {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}
</style>
